import { render } from "./UserNameForm.vue?vue&type=template&id=12415556&scoped=true"
import script from "./UserNameForm.vue?vue&type=script&lang=js"
export * from "./UserNameForm.vue?vue&type=script&lang=js"

import "./UserNameForm.vue?vue&type=style&index=0&id=12415556&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12415556"]])

export default __exports__